import apiInterceptor from '@/utils/apiInterceptor'

// 公共配置
const API_CONFIG = {
  BASE_URL: process.env.VUE_APP_KSSO_URL || 'http://gateway.keco.vip',
  APP_ID: 'agent_admin_web',
  APP_SECRET: 'G3e4DQonaj06txSCgs2XyMfWIUOz9vNw'
}

// 公共请求头
function getCommonHeaders() {
  return {
    'req_app_id': API_CONFIG.APP_ID,
    'req_app_secret': API_CONFIG.APP_SECRET
  }
}

// 公共请求头
function getSummaryHeaders() {
  return {
    'req_app_id': 'LivePlugin',
    'req_app_secret':'ewMpjg7t4vX5bK13oRZzSB8mEuNGr2Yy'
  }
}
// 公共请求参数
function getCommonParams(params = {}) {
  const {
    pageIndex = null,
    pageSize = null,
    status = null,
    startDate = null,
    endDate = null
  } = params

  const queryParams = new URLSearchParams()
  if (pageIndex !== null) queryParams.append('pageIndex', pageIndex)
  if (pageSize !== null) queryParams.append('pageSize', pageSize)
  if (status !== null) queryParams.append('status', status)
  if (startDate !== null) queryParams.append('startDate', startDate)
  if (endDate !== null) queryParams.append('endDate', endDate)

  return queryParams
}

/**
 * 创作者相关API服务
 */
class CreatorService {
  /**
   * 获取创作者线索列表
   * @param {Object} params 查询参数
   * @param {number} params.pageIndex 页码
   * @param {number} params.pageSize 每页数量
   * @param {string} params.status 状态
   * @param {string} params.startDate 开始日期
   * @param {string} params.endDate 结束日期
   * @returns {Promise<Object>} 返回数据
   */
  async getCreatorLeads(params = {}) {
    const queryParams = getCommonParams(params)
    const url = `${API_CONFIG.BASE_URL}/api/creator/leads?${queryParams.toString()}`

    try {
      const response = await apiInterceptor.get(url, {
        headers: getCommonHeaders()
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const data = await response.json()
      return data
    } catch (error) {
      console.error('获取创作者线索列表失败:', error)
      throw error
    }
  }

  /**
   * 更新创作者线索状态
   * @param {number} id 线索ID
   * @param {string} status 新状态
   * @param {string} changedBy 变更人
   * @returns {Promise<Object>} 返回数据
   */
  async updateCreatorLeadStatus(id, status, changedBy = 'keco') {
    // 构建URL参数
    const params = new URLSearchParams({
      id: id.toString(),
      status: status,
      changedBy: changedBy
    })
    
    const url = `${API_CONFIG.BASE_URL}/api/creator/lead/${id}/status?${params.toString()}`

    try {
      // 使用apiInterceptor.post方法，它会自动处理katoken
      const response = await apiInterceptor.post(url, null, {
        headers: getCommonHeaders()
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const data = await response.json()
      return data
    } catch (error) {
      console.error('更新创作者线索状态失败:', error)
      throw error
    }
  }

  /**
   * 更新创作者线索跟播优先级
   * @param {number} id 线索ID
   * @param {number} followPriority 跟播优先级
   * @param {string} changedBy 变更人
   * @returns {Promise<Object>} 返回数据
   */
  async updateCreatorLeadFollowPriority(id, followPriority, changedBy = 'keco') {
    // 构建URL参数
    const params = new URLSearchParams({
      id: id.toString(),
      followPriority: followPriority.toString(),
      changedBy: changedBy
    })
    
    const url = `${API_CONFIG.BASE_URL}/api/creator/lead/${id}/followPriority?${params.toString()}`

    try {
      const response = await apiInterceptor.post(url, null, {
        headers: {
          'req_app_id': 'live_tracking_engine',
          'req_app_secret': 'l3huSx9r0QBjIFcm2ifKEGPeoa7LZAbv'
        }
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const data = await response.json()
      return data
    } catch (error) {
      console.error('更新创作者线索跟播优先级失败:', error)
      throw error
    }
  }

  /**
   * 获取创作者详细数据
   * @param {string|Array} usernames 用户名或用户名数组
   * @returns {Promise<Object>} 返回数据
   */
  async getCreatorDetails(usernames) {
    // 如果是数组，转换为逗号分隔的字符串
    const usernameParam = Array.isArray(usernames) ? usernames.join(',') : usernames
    
    const url = `${API_CONFIG.BASE_URL}/api/creator/query?usernames=${encodeURIComponent(usernameParam)}`

    try {
      const response = await apiInterceptor.get(url, {
        headers: getCommonHeaders()
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const data = await response.json()
      return data
    } catch (error) {
      console.error('获取创作者详细数据失败:', error)
      throw error
    }
  }

  /**
   * 根据ID获取创作者信息
   * @param {number} creatorId 创作者ID
   * @returns {Promise<Object>} 返回数据
   */
  async getCreatorById(creatorId) {
    const url = `${API_CONFIG.BASE_URL}/api/creator/lead/${creatorId}`

    try {
      const response = await apiInterceptor.get(url, {
        headers: getCommonHeaders()
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const data = await response.json()
      return data
    } catch (error) {
      console.error('获取创作者信息失败:', error)
      throw error
    }
  }

  /**
   * 批量获取创作者详细数据
   * @param {Array} creators 创作者列表
   * @returns {Promise<Object>} 返回数据
   */
  async batchGetCreatorDetails(creators) {
    try {
      // 提取所有用户名
      const usernames = creators.map(creator => creator.socialHandle).filter(Boolean)
      
      if (usernames.length === 0) {
        return { data: [] }
      }

      // 获取详细数据
      const detailsData = await this.getCreatorDetails(usernames)
      
      // 将详细数据映射到创作者列表
      const creatorsWithDetails = creators.map(creator => {
        const detail = detailsData.data?.find(d => d.username === creator.socialHandle)
        if (detail) {
          return {
            ...creator,
            videos: detail.totalVideos || 0,
            followers: detail.followerCount || 0,
            likes: detail.totalLikes || 0,
            nickname: detail.nickname,
            avatarUrl: detail.avatarUrl,
            bio: detail.bio,
            isVerified: detail.isVerified
          }
        }
        return creator
      })

      return { data: creatorsWithDetails }
    } catch (error) {
      console.error('批量获取创作者详细数据失败:', error)
      return { data: creators }
    }
  }

  /**
   * 获取创作者线索统计
   * @returns {Promise<Object>} 返回统计数据
   */
  async getCreatorLeadsStats() {
    try {
      const data = await this.getCreatorLeads()
      const stats = { 
        leads: data.totalCount || 0, 
        rising: 0, 
        affiliated: 0, 
        eliminated: 0 
      }
      
      if (data.data && Array.isArray(data.data)) {
        data.data.forEach(item => {
          switch (item.status) {
            case '待处理':
              stats.rising++
              break
            case '预跟踪':
              stats.affiliated++
              break
            case '已淘汰':
              stats.eliminated++
              break
            default:
              stats.rising++
          }
        })
      }
      
      return stats
    } catch (error) {
      console.error('获取创作者线索统计失败:', error)
      return { leads: 0, rising: 0, affiliated: 0, eliminated: 0 }
    }
  }

  /**
   * 获取客户绑定列表
   * @param {Object} params 查询参数
   * @param {number} params.bindingStatus 绑定状态
   * @param {string} params.socialHandle 社交账号
   * @param {number} params.accountSn 账号SN
   * @param {number} params.pageSize 每页数量
   * @param {number} params.pageIndex 页码
   * @returns {Promise<Object>} 返回数据
   */
  async getCreatorBindingList(params = {}) {
    const url = `${API_CONFIG.BASE_URL}/api/user/creator-binding/admin/list`

    try {
      const response = await apiInterceptor.post(url, params, {
        headers: getCommonHeaders()
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const data = await response.json()
      return data
    } catch (error) {
      console.error('获取客户绑定列表失败:', error)
      throw error
    }
  }

  /**
   * 通过绑定申请
   * @param {number} id 绑定记录ID
   * @param {string} remark 备注，默认“管理员审核通过”
   * @returns {Promise<Object>} 返回数据
   */
  async approveCreatorBinding(id, remark = '管理员审核通过') {
    const url = `${API_CONFIG.BASE_URL}/api/user/creator-binding/admin/approve`

    try {
      const response = await apiInterceptor.post(url, { bindingId: id, remark }, {
        headers: getCommonHeaders()
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const data = await response.json()
      return data
    } catch (error) {
      console.error('通过客户绑定失败:', error)
      throw error
    }
  }

  /**
   * 解绑客户
   * 注意：接口路径和入参需根据后端实际实现调整
   * 这里暂时假设为 POST /api/user/creator-binding/admin/unbind，body: { id }
   * @param {number} id 绑定记录ID
   * @returns {Promise<Object>} 返回数据
   */
  async unbindCreatorBinding(id) {
    const url = `${API_CONFIG.BASE_URL}/api/user/creator-binding/admin/unbind`

    try {
      const response = await apiInterceptor.post(url, { id }, {
        headers: getCommonHeaders()
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const data = await response.json()
      return data
    } catch (error) {
      console.error('解绑客户失败:', error)
      throw error
    }
  }

  /**
   * 获取直播会话完整摘要
   * @param {string} roomId 房间ID
   * @returns {Promise<Object>} 返回数据
   */
  async getLiveSessionSummary(roomId) {
    const url = `${API_CONFIG.BASE_URL}/api/live/session/full-summary?roomId=${encodeURIComponent(roomId)}`

    try {
      const response = await apiInterceptor.get(url, {
        headers: getSummaryHeaders()
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const data = await response.json()
      return data
    } catch (error) {
      console.error('获取直播会话摘要失败:', error)
      throw error
    }
  }

  /**
   * 获取高光时刻列表
   * @param {Object} params 查询参数
   * @param {string} params.creatorId 创作者ID
   * @param {string} params.sessionId 会话ID
   * @param {number} params.pageIndex 页码
   * @param {number} params.pageSize 每页数量
   * @param {string} params.sortField 排序字段
   * @param {string} params.sortOrder 排序顺序
   * @returns {Promise<Object>} 返回数据
   */
  async getHighlightMoments(params = {}) {
    const {
      creatorId,
      sessionId,
      pageIndex = 1,
      pageSize = 10,
      sortField = 'createTime',
      sortOrder = 'desc'
    } = params

    const queryParams = new URLSearchParams({
      creatorId: creatorId,
      sessionId: sessionId,
      pageIndex: pageIndex.toString(),
      pageSize: pageSize.toString(),
      sortField: sortField,
      sortOrder: sortOrder
    })

    const url = `${API_CONFIG.BASE_URL}/api/creator/video-analysis/highlight-moments?${queryParams.toString()}`

    try {
      const response = await apiInterceptor.get(url, {
        headers: getCommonHeaders()
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const data = await response.json()
      return data
    } catch (error) {
      console.error('获取高光时刻失败:', error)
      throw error
    }
  }

  /**
   * 根据社交账号获取创作者信息
   * @param {string} socialHandle 社交账号
   * @param {string} platform 平台，默认为tiktok
   * @returns {Promise<Object>} 返回创作者信息
   */
  async getCreatorBySocialName(socialHandle, platform = 'tiktok') {
    try {

    const url = `${API_CONFIG.BASE_URL}/api/creator/lead/bySocialName?socialHandle=${socialHandle}&platform=${platform}`
      const response = await apiInterceptor.get(url, {
        
        headers: {
          'req_app_id': 'live_tracking_engine',
          'req_app_secret': 'l3huSx9r0QBjIFcm2ifKEGPeoa7LZAbv'
        }
      })
      
      const data = await response.json()
      return data
    } catch (error) {
      console.error('获取创作者信息失败:', error)
      throw error
    }
  }

  /**
   * 获取直播统计数据（互动数据）
   * @param {string} roomId 房间ID
   * @param {string} startTime 开始时间
   * @param {string} endTime 结束时间
   * @returns {Promise<Object>} 返回统计数据
   */
  async getLiveStatistics(roomId, startTime, endTime) {
    try {
      const url = `${API_CONFIG.BASE_URL}/api/live/statistics?roomId=${encodeURIComponent(roomId)}&startTime=${encodeURIComponent(startTime)}&endTime=${encodeURIComponent(endTime)}`
      const response = await apiInterceptor.get(url, {
        headers: getSummaryHeaders()
      })
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const data = await response.json()
      return data
    } catch (error) {
      console.error('获取直播统计数据失败:', error)
      throw error
    }
  }

  /**
   * 获取直播间统计数据（点赞与在线用户数）
   * @param {string} roomId 房间ID
   * @param {string} startTime 开始时间
   * @param {string} endTime 结束时间
   * @returns {Promise<Object>} 返回统计数据
   */
  async getLiveRoomStatistics(roomId, startTime, endTime) {
    try {
      const url = `${API_CONFIG.BASE_URL}/api/live/room/statistics?roomId=${encodeURIComponent(roomId)}&startTime=${encodeURIComponent(startTime)}&endTime=${encodeURIComponent(endTime)}`
      const response = await apiInterceptor.get(url, {
        headers: getSummaryHeaders()
      })
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const data = await response.json()
      return data
    } catch (error) {
      console.error('获取直播间统计数据失败:', error)
      throw error
    }
  }

  /**
   * 获取顶级送礼者排行榜
   * @param {string} roomId 房间ID
   * @param {string} sessionId 场次ID
   * @returns {Promise<Object>} 返回排行榜数据
   */
  async getTopGifters(roomId, sessionId) {
    try {
      const url = `${API_CONFIG.BASE_URL}/api/live/viewers/top/${encodeURIComponent(roomId)}?sessionId=${encodeURIComponent(sessionId)}`
      const response = await apiInterceptor.get(url, {
        headers: getSummaryHeaders()
      })
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const data = await response.json()
      return data
    } catch (error) {
      console.error('获取顶级送礼者排行榜失败:', error)
      throw error
    }
  }

  /**
   * 获取金主排行榜数据
   * @param {string} liveRoomId 直播间ID
   * @param {string} sessionId 场次ID
   * @param {number} pageSize 每页数量
   * @param {number} pageIndex 页码
   * @returns {Promise<Object>} 返回排行榜数据
   */
  async getRewardList(liveRoomId, sessionId, pageSize = 10, pageIndex = 1) {
    try {
      const url = `${API_CONFIG.BASE_URL}/api/live/viewers/reward-list?liveRoomId=${encodeURIComponent(liveRoomId)}&sessionId=${encodeURIComponent(sessionId)}&pageSize=${pageSize}&pageIndex=${pageIndex}`
      const response = await apiInterceptor.get(url, {
        headers: getSummaryHeaders()
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const data = await response.json()
      return data
    } catch (error) {
      console.error('获取金主排行榜失败:', error)
      throw error
    }
  }

  /**
   * 获取直播间评论列表
   * @param {string} sessionId 场次ID
   * @param {string} roomId 直播间ID
   * @param {number} pageIndex 页码
   * @param {number} pageSize 每页数量
   * @param {string} messageType 消息类型
   * @returns {Promise<Object>} 返回评论数据
   */
  async getLiveComments(sessionId, roomId, pageIndex = 1, pageSize = 10, messageType = 'chat') {
    try {
      const url = `${API_CONFIG.BASE_URL}/api/live/comments?sessionId=${encodeURIComponent(sessionId)}&roomId=${encodeURIComponent(roomId)}&pageIndex=${pageIndex}&pageSize=${pageSize}&messageType=${encodeURIComponent(messageType)}`
      const response = await apiInterceptor.get(url, {
        headers: getSummaryHeaders()
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const data = await response.json()
      return data
    } catch (error) {
      console.error('获取直播间评论失败:', error)
      throw error
    }
  }

  /**
   * 获取实时评论分钟统计（互动时间线数据）
   * @param {string} roomId 房间ID
   * @param {string} startTime 开始时间
   * @param {string} endTime 结束时间
   * @returns {Promise<Object>} 返回评论统计数据
   */
  async getLiveCommentMinuteStatistics(roomId, startTime, endTime) {
    try {
      const url = `${API_CONFIG.BASE_URL}/api/live/comment/minute/statistics?roomId=${encodeURIComponent(roomId)}&startTime=${encodeURIComponent(startTime)}&endTime=${encodeURIComponent(endTime)}`
      const response = await apiInterceptor.get(url, {
        headers: getSummaryHeaders()
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const data = await response.json()
      return data
    } catch (error) {
      console.error('获取实时评论分钟统计失败:', error)
      throw error
    }
  }

  /**
   * 获取打赏贡献分布统计
   * @param {string} liveRoomId 直播间ID
   * @param {string} sessionId 场次ID
   * @returns {Promise<Object>} 返回贡献分布数据
   */
  async getContributionStats(liveRoomId, sessionId) {
    try {
      const url = `${API_CONFIG.BASE_URL}/api/live/viewers/contribution-stats?liveRoomId=${encodeURIComponent(liveRoomId)}&sessionId=${encodeURIComponent(sessionId)}`
      const response = await apiInterceptor.get(url, {
        headers: getSummaryHeaders()
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const data = await response.json()
      return data
    } catch (error) {
      console.error('获取打赏贡献分布统计失败:', error)
      throw error
    }
  }
}

export default new CreatorService()
